import React from 'react';
import css from './index.css';
import {Icon,Box,Grid, Card, CardActions,CardContent, List, ListItemText,ListItem} from '@material-ui/core';
import {Work} from '@material-ui/icons';
import {useTranslation} from 'react-i18next';

export default function Experience() {

const {t,i18n}=useTranslation();
    
    return (
        <Box>
        <Grid item xs={12}>
        <Grid container justify="center">
        <List>
        <ListItem>
        <Card style={{ width:"100%" }}>
        <CardActions>
        <CardContent>
        <List>
        <ListItem><strong> <Icon><Work/></Icon>{t('experiencetile1.label')}</strong></ListItem>
        <ListItem>
        {t('experiencedescription1.label')} 
        </ListItem>
        </List>
        </CardContent>
        </CardActions>
        </Card>
        </ListItem>
        <ListItem>
        <Card style={{ width:"100%" }}>
        <CardActions>
        <CardContent>
        <List>
        <ListItem><strong><Icon><Work/></Icon>{t('experiencetile2.label')}</strong></ListItem>
        <ListItem>
        {t('experiencedescription2.label')}
        </ListItem>
        </List>
        </CardContent>
        </CardActions>
        </Card>
        </ListItem>
        <ListItem>
        <Card style={{ width:"100%" }}>
        <CardActions>
        <CardContent>
        <List>
        <ListItem><strong><Icon><Work/></Icon> {t('experiencetile3.label')}</strong></ListItem>
        <ListItem>
        {t('experiencedescription3.label')}
        </ListItem>
        </List>
        </CardContent>
        </CardActions>
        </Card>
        </ListItem>
        </List>
        </Grid>
        </Grid>
        </Box>
    );
}